import styled from 'styled-components';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 60px 2px 1fr;
	gap: 20px;
	height: 100px;
	padding: 0 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	align-items: center;

	& > img {
		width: 60px;
		height: 60px;
		user-select: none;
		pointer-events: none;
		border-radius: 5px;
	}

	.dividers {
		display: flex;

		${Divider} {
			height: 60px;
		}
	}
`;

const StyledRightContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	height: 100%;
`;

const StyledTopContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-top: 17px;
`;

const StyledNameProgressContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	${Text} {
		&:first-child {
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
		}

		&:last-child {
			font-weight: 400;
			font-size: 12px;
			color: rgba(255, 255, 255, 0.5);

			span {
				font-weight: 500;
				color: #ffffff;
			}
		}
	}
`;

const StyledLevelContainer = styled.div<{ $active?: boolean }>`
	width: 30px;
	height: 30px;
	background-color: ${({ $active }) =>
		$active ? '#1AB248' : 'rgba(255, 255, 255, 0.05)'};
	border: ${({ $active }) =>
		$active ? '#1AB248' : '1px solid rgba(255, 255, 255, 0.1)'};
	border-radius: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition:
		background-color 0.3s ease,
		border 0.3s ease;

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledBottomContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 20px;
	gap: 10px;
`;

const StyledProgressWrapper = styled.div`
	position: relative;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	padding: 2px;
	border-radius: 5px;
`;

const StyledProgress = styled.div`
	height: 100%;
	background-color: #1ab248;
	border-radius: 3px;
`;

const StyledInfoButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	transition: background-color 0.2s ease;
	cursor: pointer;

	&:hover {
		background-color: rgba(255, 255, 255, 0.1);
	}

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledBottomContainer,
	StyledContainer,
	StyledInfoButton,
	StyledLevelContainer,
	StyledNameProgressContainer,
	StyledProgress,
	StyledProgressWrapper,
	StyledRightContainer,
	StyledTopContainer,
};
